import { IServiceInfo } from "@/domain/entities/serviceInfo/serviceInfo.types";
import TYPES from "@/ioc/identifiers";
import { SERVICE_CODE } from "@/types";
import useGetProtocolHost from "@/use/useGetProtocolHost";
import { inject, injectable } from "inversify";
import { Result } from "neverthrow";
import { HttpError } from "../shared/errors/httpError";
import { ParseError } from "../shared/errors/parseError";
import { IHttpService } from "../shared/httpService";
import {
  IServiceInfoParser,
  IServiceInfoRepository,
  HttpServiceInfoResponse,
} from "./serviceInfoRepository.types";

@injectable()
export class ServiceInfoRepository implements IServiceInfoRepository {
  @inject(TYPES.IServiceInfoParser)
  private serviceInfoParser!: IServiceInfoParser;

  private httpService: IHttpService;

  constructor(@inject(TYPES.IHttpService) httpService: IHttpService) {
    this.httpService = httpService;
    this.httpService.initService(
      `${useGetProtocolHost()}/aibos/client/api/${
        process.env.VUE_APP_API_VERSION
      }/public/service/`
    );
  }

  async getServiceInfo(): Promise<
    Result<IServiceInfo, ParseError | HttpError>
  > {
    const parseTo = (response: HttpServiceInfoResponse) => {
      return this.serviceInfoParser.toDomain(response.data);
    };
    return await this.httpService.get<HttpServiceInfoResponse, IServiceInfo>(
      {
        url: SERVICE_CODE,
      },
      { parseTo }
    );
  }
}
